// extracted by mini-css-extract-plugin
export default {"difference":"FeesOverrideTableBody_difference__fXVU2","alreadyPaid":"FeesOverrideTableBody_alreadyPaid__+XPgV"};